export default "__VITE_ASSET__CAFuYorY__"